module.exports = __webpack_public_path__ + "img/icon-info.5c0d04e2.svg";